import { STEPS } from 'consts/flowConsts'
import routes from 'consts/routes'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'

dayjs.extend(isBetween)

export const getRouteByStepDone = ({ step, isOEP }) => {
  // after step is done, getting the next route
  switch (step) {
    case STEPS.ZIP_CODE:
      return routes.ENROLL_INFO
    case STEPS.INFO:
      // on oep we should skip qualification step
      return isOEP ? routes.ENROLL_PLAN_RANK : routes.ENROLL_QUALIFICATION
    case STEPS.QUALIFICATION:
      return routes.ENROLL_PLAN_RANK
    case STEPS.PLAN_RANK:
      return routes.ENROLL_PLANS
    case STEPS.PLANS:
      return routes.ENROLL_MEMBER_DETAILS
    case STEPS.DETAILS:
      return routes.ENROLL_FINALIZE
    case STEPS.FINALIZE:
      return routes.ENROLL_SUCCESS
    default:
      return routes.ROOT
  }
}

export const shouldOpenSaveProgressDialog = saveProgressDialogTimeToOpen => {
  const saveProgressDialogTimeToOpenFromLocalStorage = localStorage.getItem(
    'saveProgressDialogTimeToOpen'
  )
  if (
    !saveProgressDialogTimeToOpen &&
    !saveProgressDialogTimeToOpenFromLocalStorage
  )
    return true
  const now = dayjs()
  // on specific session, when state is presisted, check the saveProgressDialogTimeToOpen from the state
  // otherwise, check the localstorage
  const timeToOpen = dayjs(
    saveProgressDialogTimeToOpen || saveProgressDialogTimeToOpenFromLocalStorage
  )
  const diff = now.diff(timeToOpen, 'seconds')
  // we should open the dialog only if now time is greater than the time to open
  return diff >= 0
}

export const scrollToError = () => {
  const errorElements = document.getElementsByClassName('error')
  const errorElement = [...errorElements]?.find(
    element => !!element?.innerText?.length
  )
  errorElement?.scrollIntoView({ block: 'center', behavior: 'smooth' })
}

export const isOEP = appConfig => {
  const now = dayjs()
  const enrollmentDates = appConfig?.enrollment_dates
  // oep is between the start date of the first oep and the end date of the second oep
  const oepStart = dayjs(enrollmentDates?.OEP1?.startDate)
  const eopEnd = dayjs(enrollmentDates?.OEP2?.endDate)
  return now.isBetween(oepStart, eopEnd)
}

// the oep is divided into two parts, oep1 and oep2
// the coverage start date is different for each part
export const getOEPCoverageDate = appConfig => {
  const now = dayjs()
  const enrollmentDates = appConfig?.enrollment_dates
  // oep1 is between the start date of the first oep and the end date of the first oep
  const oepStart = dayjs(enrollmentDates?.OEP1?.startDate)
  const oepEnd = dayjs(enrollmentDates?.OEP1?.endDate)
  const isOEP1 = now.isBetween(oepStart, oepEnd)
  return isOEP1
    ? enrollmentDates?.OEP1?.coverageDate
    : enrollmentDates?.OEP2?.coverageDate
}

export const convertDate = (isoDateString, format = 'MM/DD/YYYY') => { 
  const date = isoDateString ? dayjs(isoDateString) : dayjs();
  return date.format(format);
}